<template>
  <ActionsWrapper class="mt-4" align-right>
    <template v-if="isComposing" #composeActions>
      <div class="compose-actions">
        <Avatar is-owner />
        <div class="compose-actions__form">
          <v-textarea
            v-model="answer"
            name="textField"
            :label="$t('message.reviews.yourAnswer')"
            v-validate.persist="'required'"
            :error-messages="errors.collect('textField')"
            autofocus
            rows="3"
          ></v-textarea>
          <ComposeActions @cancel="handleCancel" @publish="handlePublish" />
        </div>
      </div>
    </template>
    <template v-else #publishActions>
      <NormalActions @use-template="handleUseTemplate" @reply="handleReply" />
    </template>
  </ActionsWrapper>
</template>

<script>
import NormalActions from "@/components/QuestionsAndAnswers/QaListItemNormalActions.vue";
import ComposeActions from "@/components/QuestionsAndAnswers/QaListItemComposeActions.vue";
import ActionsWrapper from "@/components/QuestionsAndAnswers/QaListItemActionsWrapper.vue";
import Avatar from "@/components/QuestionsAndAnswers/QaAvatar.vue";

import cuid from "cuid";
export default {
  name: "QaListItemPublishActions",
  components: {
    NormalActions,
    ComposeActions,
    ActionsWrapper,
    Avatar
  },
  data() {
    return {
      answer: "",
      isComposing: false,
      formId: cuid()
    };
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
      this.isComposing = false;
      this.$validator.reset();
    },
    handlePublish() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("publish", this.answer);
          this.isComposing = false;
          this.answer = "";
          this.$validator.reset();
        }
      });
    },
    handleUseTemplate() {
      this.$emit("use-template");
      this.isComposing = false;
    },
    handleReply() {
      this.isComposing = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.compose-actions {
  display: flex;
  gap: $spacing * 2;
  width: 100%;
  flex-grow: 1;

  &__form {
    width: 100%;
    margin-left: $spacing * 2;
  }
}
</style>
